













import {
  Component,
  Prop,
  //   Ref,
  Vue
//   Watch
} from 'vue-property-decorator'
// import {
//   component
// } from 'vue/types/umd'

@Component
export default class ContactCovid extends Vue {
  @Prop() link: string | undefined
  showMenu () {
    window.open(this.link)
  }
}
